import { render, staticRenderFns } from "./TepLiquidacionPlanilla.vue?vue&type=template&id=2cb9cd46"
import script from "./TepLiquidacionPlanilla.vue?vue&type=script&lang=js"
export * from "./TepLiquidacionPlanilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports